import { render, staticRenderFns } from "./AddAdditionalBillingModal.vue?vue&type=template&id=554ba459&"
import script from "./AddAdditionalBillingModal.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalBillingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports